import { useUserIdentityState } from '@provider/user-identity';
import { PublisherLogo } from '@ui/kit/icons';
import { DESIGN_SIZES } from '../constants.js';
import { footer, pageContext, pageNumber, copyright, publisherLogo } from './pm2.footer.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function makePM2PrintFooterSlot(type) {
  return context => ({
    content: /*#__PURE__*/jsx(PM2PrintFooter, {
      type: type,
      context: context
    }),
    designSizeInPx: DESIGN_SIZES.ONE_TO_ONE(context.format)
  });
}
function PM2PrintFooter(props) {
  const user = useUserIdentityState(state => state.user);
  const typeLabel = (() => {
    switch (props.type) {
      case "arbejdsark":
        return "Dette arbejdsark";
      case "pdf":
        return "Denne pdf";
    }
  })();
  const userLabel = (() => {
    const date = new Date().toLocaleDateString("da-DK", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric"
    });
    if (user?.institution?.name && user.name) {
      return `${typeLabel} er udskrevet af ${user.name}, ${user.institution.name}, ${date}.`;
    }
    if (user?.name) {
      return `${typeLabel} er udskrevet af ${user.name}, ${date}.`;
    }
    return `${typeLabel} er udskrevet ${date}.`;
  })();
  return /*#__PURE__*/jsxs("footer", {
    className: footer,
    children: [/*#__PURE__*/jsx("div", {
      className: pageContext,
      children: props.context.physical && /*#__PURE__*/jsxs("span", {
        className: pageNumber,
        children: [/*#__PURE__*/jsx("b", {
          children: props.context.physical.currentPageIndexInDocument + 1
        }), "/", props.context.physical.pagesInDocument]
      })
    }), /*#__PURE__*/jsxs("div", {
      className: copyright,
      children: ["Print og kopiering af dette materiale er tilladt, forudsat at det sker i overensstemmelse med skolens aftale med Tekst & Node.", /*#__PURE__*/jsx("br", {}), userLabel]
    }), /*#__PURE__*/jsx("div", {
      className: pageContext,
      children: /*#__PURE__*/jsx(PublisherLogo, {
        small: true,
        className: publisherLogo
      })
    })]
  });
}

export { makePM2PrintFooterSlot };
//# sourceMappingURL=pm2.footer.js.map
